import { PartRelationItem } from "@/types/partRelation";
import { BaseService } from "./BaseService";

export interface PutPartRelationRequest {
  record: PartRelationItem;
  oldRecord?: PartRelationItem;
}

export interface PartRelationRequest {
  partId?: string;
  optionGroupId?: string;
  customerId?: string;
}

export default class PartRelationService extends BaseService {
  async fetchPartRelation(partRelationRequest: PartRelationRequest): Promise<any> {
    const response = await this.submit("partrelation", "GET", undefined, partRelationRequest);
    return response;
  }
  
  async createPartRelation(partRelation: PartRelationItem): Promise<any> {
    const putrecord = { record: partRelation };
    const response = await this.submit("partrelation", "POST", putrecord);
    return response;
  }
  
  async removePartRelationById(id: string): Promise<any> {
    const response = await this.submit(`partrelation/${id}`, "DELETE");
    return response;
  }
  
  async updatePartRelationById(putPartRelationRequest: PutPartRelationRequest): Promise<any> {
    const response = await this.submit(
      `UpdatePartRelation/${putPartRelationRequest.record.option_group_id}`,
      "PUT",
      putPartRelationRequest,
    );
    return response;
  }
}
